/* ============================================================================
   Big Z's product page buy box order (2026-10-22). ZZ asked for "what you find most ideal" for where Add to
   Cart sits. The button came after the starter kit offer and the Frequently paired block, about two screens
   down on a laptop. Now the order is: size, quantity, the paired add-on (it is a checkbox that rides along
   with Add to Cart, so it has to stay above the button), Add to Cart, then the starter kit offer, which reads
   as "complete the setup" once the animal is in the bag.
   This only moves the starter kit block that is already on the page (snippets/bz-habitat-addon output, the
   .bzp-kit card) to just after the product form. Nothing is rebuilt, so the form, the kit's own buttons and
   the variant scripts keep working. If the product page re-renders its buy column, it is moved again.
   Loaded on product pages by snippets/bz-fix-layer, which also trims the paired block's duplicate
   "Selected animal" card. To undo, delete the script tag there.
   ========================================================================== */
(function () {
  'use strict';
  if (window.bzBuybox) return;
  window.bzBuybox = true;
  function arrange() {
    var buy = document.querySelector('.bz-product-buy');
    if (!buy) return;
    var form = buy.querySelector('form.bz-product-form');
    var kit = buy.querySelector('.bzp-kit');
    if (!form || !kit || form.contains(kit)) return;
    var box = kit;
    while (box.parentElement && box.parentElement !== buy) box = box.parentElement;
    if (box.parentElement !== buy || box === form || form.nextElementSibling === box) return;
    form.after(box);
    box.classList.add('bz-kit-after');
  }
  arrange();
  var buy = document.querySelector('.bz-product-buy');
  if (buy && window.MutationObserver) new MutationObserver(arrange).observe(buy, { childList: true });
})();
